import Skeleton from '@mui/material/Skeleton'
import Typography from '@mui/material/Typography'
import { css, styled } from '@mui/material/styles'
import { colors } from '@theme/variables'

export const CARD_IMAGE_DIMENSION = 59
export const CARD_IMAGE_OVERLAP = 15

export const CardsListWrapper = styled('div')`
  width: 100%;
  position: relative;
`
export const CardsListWrapperInner = styled('div')`
  width: 100%;
  display: flex;
`

export const CardImageBox = styled('div')`
  border-radius: 50%;
  overflow: hidden;
  background-color: ${colors.grey};
  box-shadow: -1px 0 4px rgba(0, 0, 0, 0.15);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  ${(props: { overlapSize?: number; $itemWidth?: number; $isDisabled?: boolean }) =>
    css`
      margin-right: ${props.overlapSize || 0}px;
      width: ${props.$itemWidth || CARD_IMAGE_DIMENSION}px;
      height: ${props.$itemWidth || CARD_IMAGE_DIMENSION}px;
      pointer-events: ${props.$isDisabled ? 'none' : 'auto'};
      cursor: ${props.$isDisabled ? 'auto' : 'pointer'};
    `}
`

export const CardPicture = styled('img')`
  width: 100%;
  height: 100%;
  ${(props: { $isDisabled?: boolean }) =>
    css`
      opacity: ${props.$isDisabled ? '0.2' : '1'};
    `}
`

export const CardImageAltInfo = styled('div')`
  font-weight: 500;
  display: flex;
  flex-direction: center;
  align-items: center;
  color: ${colors.bodyText};
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: center;
  justify-content: center;

  ${(props: { seeMoreButtonView?: boolean; $itemWidth?: number; $isDisabled?: boolean }) =>
    props.seeMoreButtonView
      ? css`
          background-color: ${colors.orange};
          color: ${colors.white};
          cursor: pointer;
          font-size: ${props.$itemWidth && props.$itemWidth < 35 ? 20 : 25};
        `
      : css`
          opacity: ${props.$isDisabled ? '0.2' : '1'};
        `}
`

export const CardTooltipWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  gap: 6px;

  ${(props: { verticalPadding?: number; horizontalPadding?: number }) =>
    props.verticalPadding || props.horizontalPadding
      ? css`
          padding: ${props.verticalPadding || 0}px ${props.horizontalPadding || 0}px;
          flex-direction: column;
        `
      : ''}
`
export const CardTooltipTitle = styled(Typography)`
  color: ${colors.primary};
`

export const PopoverListWrapper = styled('div')`
  max-width: 290px;
  width: 100%;
`

export const PopoverList = styled('div')`
  position: relative;
  max-height: 300px;
  overflow: auto;
  padding-top: 10px;
`
export const PopoverListInner = styled('div')`
  display: flex;
  flex-direction: column;
`

export const PopoverItemCard = styled('div')`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 10px 16px;
  gap: 10px;

  &:not(:first-child) {
    border-top: 1px solid ${colors.commonLightGrey};
  }
`

export const PopoverCardImageSkeleton = styled(Skeleton)`
  width: ${CARD_IMAGE_DIMENSION}px;
  height: ${CARD_IMAGE_DIMENSION}px;
`

export const PopoverCardInfoSectionSkeleton = styled('div')`
  width: 100%;
`

export const PopoverCardTextSkeleton = styled(Skeleton)`
  width: 82%;
  height: 20px;
  margin-left: 15%;
`
